import {swiperInit} from './swiperInit';

export const activitiesSwiper = (() => {
  swiperInit({
    breakpoints: {
      480: {
        slidesPerView: "auto",
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    selector: '.activitiesSwiper',
  })
})();
